import { cn } from '@utils/helpers';
import { useFragment } from 'react-relay';
import { fileLinkFragment } from './FileLink.relay';
import { fileLinkClassName } from './lib/FileLinkStyles';
import type { FileLinkPropsType } from './types';

const FileLink: React.FC<FileLinkPropsType> = (props: FileLinkPropsType) => {
  const fileLink = useFragment(fileLinkFragment, props.fileLink);

  let header = fileLink.header;
  const { date, url, text, format, size, smallicon, largeicon } = fileLink;

  if (!header && !text && !props.expanded) {
    header = '–';
  }

  return (
    <a href={url} className={`${fileLinkClassName} FileLink`} target="_blank" rel="noreferrer">
      {(largeicon && props.expanded) || smallicon ? (
        <span className="FileLink-icon">
          {props.expanded || !smallicon ? (
            <img aria-label="file-link-icon" src={process.env.HOST + largeicon} />
          ) : (
            <img aria-label="file-link-icon-small" className="FileLink-icon-small" src={process.env.HOST + smallicon} />
          )}
        </span>
      ) : null}

      {/* <span className="FileLink-content bg-green-200"> */}
      <span className={cn('flex gap-2 items-baseline-last', props.expanded && 'flex-col gap-0! pt-1')}>
        {header ? <span className="text-xs uppercase text-accent">{header}</span> : null}
        {props.expanded ? <span className="FileLink-info FileLink-expanded text-xs">{text}</span> : null}
        {format ? (
          <span className="FileLink-info text-xs">
            {date} | {format.replace(/application\//g, '')} {size !== '0 B' ? ` | ${size}` : ''}
          </span>
        ) : null}
      </span>
    </a>
  );
};

export { FileLink };
